import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePortalRole, ROLE_PRIORITY } from '../../contexts/PortalRoleContext';
import { getRoleDisplayName } from '../../utils/portalPermissions';
import * as S from './PortalHome.styles';

// 图标组件
const Icons = {
  Users: () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  ),
  Students: () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
    </svg>
  ),
  Campus: () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
  ),
  Courses: () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
    </svg>
  ),
  Materials: () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
    </svg>
  ),
  Billing: () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
  ),
  Profile: () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
  Dashboard: () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
    </svg>
  ),
  Children: () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
  ),
  Tips: () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
    </svg>
  ),
};

const PortalHome = () => {
  const { currentRole, userRoles, currentUserCampus } = usePortalRole();
  const navigate = useNavigate();

  // 定义每个角色的功能入口
  const getQuickLinks = () => {
    const links = {
      system_admin: [
        { path: '/portal/users', title: 'User Management', description: 'Manage system users and permissions', icon: Icons.Users, color: '#6366f1' },
        { path: '/portal/students', title: 'Student Management', description: 'View and manage all students', icon: Icons.Students, color: '#F1AF59' },
        { path: '/portal/campuses', title: 'Campus Management', description: 'Manage campus locations', icon: Icons.Campus, color: '#10b981' },
        { path: '/portal/course-groups', title: 'Course Groups', description: 'Manage all course groups', icon: Icons.Courses, color: '#8b5cf6' },
        { path: '/portal/materials', title: 'Materials', description: 'Manage teaching materials', icon: Icons.Materials, color: '#ec4899' },
        { path: '/portal/teaching-tips', title: 'Teaching Tips', description: 'Announcements for teaching staff', icon: Icons.Tips, color: '#f97316' },
        { path: '/portal/billing', title: 'Billing', description: 'View billing and payments', icon: Icons.Billing, color: '#f59e0b' },
        { path: '/portal/admin-profile', title: 'My Profile', description: 'View and edit your profile', icon: Icons.Profile, color: '#64748b' },
      ],
      director: [
        { path: '/portal/users', title: 'User Management', description: 'Manage system users and permissions', icon: Icons.Users, color: '#6366f1' },
        { path: '/portal/students', title: 'Student Management', description: 'View and manage all students', icon: Icons.Students, color: '#F1AF59' },
        { path: '/portal/campuses', title: 'Campus Management', description: 'Manage campus locations', icon: Icons.Campus, color: '#10b981' },
        { path: '/portal/course-groups', title: 'Course Groups', description: 'Manage all course groups', icon: Icons.Courses, color: '#8b5cf6' },
        { path: '/portal/materials', title: 'Materials', description: 'Manage teaching materials', icon: Icons.Materials, color: '#ec4899' },
        { path: '/portal/teaching-tips', title: 'Teaching Tips', description: 'Post announcements for teaching staff', icon: Icons.Tips, color: '#f97316' },
        { path: '/portal/billing', title: 'Billing', description: 'View billing and payments', icon: Icons.Billing, color: '#f59e0b' },
        { path: '/portal/admin-profile', title: 'My Profile', description: 'View and edit your profile', icon: Icons.Profile, color: '#64748b' },
      ],
      manager: [
        { path: '/portal/students', title: 'Students', description: 'Manage students in your campus', icon: Icons.Students, color: '#F1AF59' },
        { path: '/portal/course-groups', title: 'Course Groups', description: 'Manage course groups', icon: Icons.Courses, color: '#8b5cf6' },
        { path: '/portal/materials', title: 'Materials', description: 'View teaching materials', icon: Icons.Materials, color: '#ec4899' },
        { path: '/portal/teaching-tips', title: 'Teaching Tips', description: 'View announcements for staff', icon: Icons.Tips, color: '#f97316' },
        { path: '/portal/admin-profile', title: 'My Profile', description: 'View and edit your profile', icon: Icons.Profile, color: '#64748b' },
      ],
      admin: [
        { path: '/portal/students', title: 'Students', description: 'Manage students in your campus', icon: Icons.Students, color: '#F1AF59' },
        { path: '/portal/course-groups', title: 'Course Groups', description: 'Manage course groups', icon: Icons.Courses, color: '#8b5cf6' },
        { path: '/portal/materials', title: 'Materials', description: 'View teaching materials', icon: Icons.Materials, color: '#ec4899' },
        { path: '/portal/teaching-tips', title: 'Teaching Tips', description: 'View announcements for staff', icon: Icons.Tips, color: '#f97316' },
        { path: '/portal/admin-profile', title: 'My Profile', description: 'View and edit your profile', icon: Icons.Profile, color: '#64748b' },
      ],
      teacher: [
        { path: '/portal/my-course-groups', title: 'My Courses', description: 'View and manage your courses', icon: Icons.Courses, color: '#8b5cf6' },
        { path: '/portal/teacher-dashboard', title: 'My Dashboard', description: 'View your teaching dashboard', icon: Icons.Dashboard, color: '#F1AF59' },
        { path: '/portal/teaching-tips', title: 'Teaching Tips', description: 'View announcements and resources', icon: Icons.Tips, color: '#f97316' },
        { path: '/portal/materials', title: 'Materials', description: 'View teaching materials', icon: Icons.Materials, color: '#ec4899' },
        { path: '/portal/teacher-profile', title: 'Teacher Profile', description: 'View and edit your profile', icon: Icons.Profile, color: '#64748b' },
      ],
      parent: [
        { path: '/portal/my-course-groups', title: "My Children's Classes", description: "View your children's enrolled courses", icon: Icons.Children, color: '#F1AF59' },
        { path: '/portal/parent-profile', title: 'My Profile', description: 'View and edit your profile', icon: Icons.Profile, color: '#64748b' },
      ],
    };

    /**
     * Every shortcut this person has, not just their most senior role's.
     *
     * Holding several roles at once is normal: a manager who also teaches, a teacher whose own
     * child attends. Keying this off the single highest role hid half of what those people come
     * here to do — a manager who teaches saw no way to reach their own classes at all. Roles are
     * walked most senior first so the ordering is stable, and destinations already offered are
     * not repeated.
     */
    const seen = new Set();
    return ROLE_PRIORITY
      .filter(role => (userRoles || []).includes(role))
      .flatMap(role => links[role] || [])
      .filter(link => {
        if (seen.has(link.path)) return false;
        seen.add(link.path);
        return true;
      });
  };

  const getWelcomeMessage = () => {
    const messages = {
      system_admin: { title: 'Welcome, System Admin', subtitle: 'System-wide administration and management' },
      director: { title: 'Welcome, Director', subtitle: 'Platform overview and management' },
      manager: { title: 'Welcome, Manager', subtitle: currentUserCampus ? `Managing ${currentUserCampus} Campus` : 'Campus Management Dashboard' },
      admin: { title: 'Welcome, Admin', subtitle: currentUserCampus ? `${currentUserCampus} Campus` : 'Campus Administration' },
      teacher: { title: 'Welcome, Teacher', subtitle: 'Your teaching portal' },
      parent: { title: 'Welcome, Parent', subtitle: "Your children's learning portal" },
    };
    return messages[currentRole] || { title: 'Welcome', subtitle: getRoleDisplayName(currentRole) };
  };

  const quickLinks = getQuickLinks();
  const welcome = getWelcomeMessage();

  return (
    <S.DashboardContainer>
      <S.WelcomeSection>
        <h1>{welcome.title}</h1>
        <p>{welcome.subtitle}</p>
      </S.WelcomeSection>

      <S.QuickLinksGrid>
        {quickLinks.map((link) => {
          const IconComponent = link.icon;
          return (
            <S.QuickLinkCard
              key={link.path}
              onClick={() => navigate(link.path)}
            >
              <S.QuickLinkIcon color={link.color}>
                <IconComponent />
              </S.QuickLinkIcon>
              <S.QuickLinkContent>
                <S.QuickLinkTitle>{link.title}</S.QuickLinkTitle>
                <S.QuickLinkDescription>{link.description}</S.QuickLinkDescription>
              </S.QuickLinkContent>
            </S.QuickLinkCard>
          );
        })}
      </S.QuickLinksGrid>
    </S.DashboardContainer>
  );
};

export default PortalHome;
